import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '@/redux-config/entities/user';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CustomBreadCrumb } from '@/components/customBreadCrumb';
import { PermissionType } from '@/DTO';
import { RoleApi } from '@/api';
import Swal from 'sweetalert2';
import { CustomInput } from '@/components';
import { useTranslation } from 'react-i18next';

export const PermissionPage: React.FC<{}> = () => {
  const { t } = useTranslation();

  const user = useSelector(selectUser);
  const [permissionsList, setPermissionsList] = useState<PermissionType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedPermissionsId, setSelectedPermissionsId] = useState<string[]>(
    [],
  );
  const [isAllCheck, setIsAllCheck] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const navigate = useNavigate();

  const crumbs = [
    { name: '', href: '' },
    { name: 'Dashboard', href: '/' },
    { name: 'Role list', href: '/roles' },
    { name: 'Edit ', href: '#' },
  ];

  useEffect(() => {
    fetchApi();
  }, []);

  useEffect(() => {
    const allList = handleGetAllPermissionId();
    if (
      allList.length === selectedPermissionsId.length &&
      selectedPermissionsId.length !== 0
    ) {
      setIsAllCheck(true);
    } else {
      setIsAllCheck(false);
    }
  }, [selectedPermissionsId]);

  const fetchApi = () => {
    setLoading(true);
    RoleApi.GetPermissionList(user)
      .then((data) => {
        setPermissionsList(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleCheckBoxChange = (id: string) => {
    if (selectedPermissionsId.indexOf(id) >= 0) {
      let list: string[] = selectedPermissionsId;
      const deleteList = list.filter((data) => data != id);
      setSelectedPermissionsId(deleteList);
    } else {
      setSelectedPermissionsId([...selectedPermissionsId, id]);
    }
  };

  const handleGetAllPermissionId = (): string[] => {
    let list: string[] = [];
    for (var i = 0; i < permissionsList.length; i++) {
      var permissions = permissionsList[i].permission_list;
      for (var j = 0; j < permissions.length; j++) {
        var id = permissions[j];
        list.push(id);
      }
    }
    return list;
  };

  const handleAllClick = () => {
    let list = handleGetAllPermissionId();
    if (
      list.length !== selectedPermissionsId.length ||
      selectedPermissionsId.length === 0
    ) {
      setSelectedPermissionsId(list);
    } else {
      setSelectedPermissionsId([]);
    }
  };

  const handleIsCheck = (id: string): boolean => {
    if (selectedPermissionsId.indexOf(id) >= 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleCreateNewRoles = () => {
    setLoading(true);
    RoleApi.CreateRole(user, name, selectedPermissionsId)
      .then((data) => {
        setLoading(false);
        Swal.fire({
          text: 'Your Role was changed',
          icon: 'success',
        }).then(() => {
          navigate('/roles');
        });
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | New Role</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className="d-flex flex-column bg-custom-white rounded p-3">
          <div className="d-flex flex-row justify-content-between align-items-center mb-4">
            <div className="d-flex flex-row flex-wrap">
              <label className="mx-2 d-flex flex-column">
                <span className="mb-0">{t('Name')}</span>
                <CustomInput
                  name={'role-name'}
                  className={'custom-input border-reg'}
                  disabled={name === 'Coach'}
                  type={'text_number'}
                  placeholder={t('Name') + ''}
                  onChange={setName}
                  value={name}
                />
              </label>
            </div>
            <label className="d-flex flex-row justify-content-between">
              <span style={{ cursor: 'pointer' }}>Select All</span>
              <input
                name="group1"
                type={'checkbox'}
                className="mx-2"
                id={'selectAll'}
                onChange={() => {
                  handleAllClick();
                  setIsAllCheck(!isAllCheck);
                }}
                checked={isAllCheck}
              />
            </label>
          </div>
          <div className="d-flex flex-row flex-wrap ">
            {permissionsList.map((item, index) => (
              <div
                className="d-flex flex-column border col-12 col-md-6 col-lg-4 p-2"
                key={index}
              >
                <strong>{item.group}</strong>
                <ul className="d-flex flex-column">
                  {item?.permission_list.map((data, index) => (
                    <li key={index}>
                      <label className="d-flex flex-row justify-content-between">
                        <span
                          style={{
                            cursor: 'pointer',
                          }}
                        >
                          {data}
                        </span>
                        <input
                          name="group1"
                          type={'checkbox'}
                          id={String(data)}
                          onChange={(e) => {
                            handleCheckBoxChange(data);
                          }}
                          checked={handleIsCheck(data)}
                        />
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="d-flex flex-row justify-content-end">
            <button
              className={'prm-btn rounded-3'}
              disabled={selectedPermissionsId.length <= 0 || name.length <= 1}
              onClick={() => {
                handleCreateNewRoles();
              }}
            >
              {t('submit')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
